// extracted by mini-css-extract-plugin
module.exports = {"stats":"go_stats__A29g0","profile":"go_profile__5p7nw","about":"go_about__H50L3","empty":"go_empty__Afgmd"};